module.exports = "<button *ngIf=\"url\" (click)=\"goTo(url)\" type=\"button\" rel=\"tooltip\" title=\"Go to page\" class=\"btn btn-danger btn-simple btn-xs\">\n    <i class=\"material-icons\">link</i>\n</button>"


//////////////////
// WEBPACK FOOTER
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/projects/shared/go-to-url/go-to-url.component.html
// module id = ../../../../../src/app/projects/shared/go-to-url/go-to-url.component.html
// module chunks = main